import { Button, Tooltip } from "prism-react";
import type { MouseEventHandler } from "react";

export const PullRequestTitle: React.FC<{
  title: string;
  number: number;
  onClick: MouseEventHandler;
}> = ({ title, number, onClick }) => (
  <Tooltip content={title}>
    <Button
      css={{
        padding: 0,
        maxWidth: 250,
      }}
      onClick={onClick}
    >
      #{number} {title}
    </Button>
  </Tooltip>
);
